import { ChevronDown } from "lucide-react";
import { useState } from "react";

export default function CharacterSidebar({
  selectedFilters,
  onFilterChange,
  onClearFilters,
  hasActiveFilters,
}) {
  const [filterSectionsOpen, setFilterSectionsOpen] = useState({
    gender: true,
    ageCategory: true,
  });

  const filterOptions = {
    gender: ["male", "female"],
    ageCategory: ["child", "young", "middle_aged", "old"],
  };

  const ageCategoryLabel = (value) => {
    const labels = {
      child: "Child",
      young: "Young",
      middle_aged: "Middle Aged",
      old: "Old",
    };
    return labels[value] || value;
  };

  const toggleFilterSection = (section) => {
    setFilterSectionsOpen((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <aside className="w-52 flex-shrink-0">
      <div className="rounded-2xl border border-gray-200 bg-white p-4 sticky top-6 max-h-[calc(100vh-100px)] overflow-y-auto custom-scrollbar">
        <div className="flex items-center justify-between mb-4">
          <h3 className="form-step-title">Filters</h3>
          {hasActiveFilters && (
            <button
              onClick={onClearFilters}
              className="h-7 px-2 text-xs rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              Clear all
            </button>
          )}
        </div>

        <div className="space-y-2">
          {/* Gender Filter */}
          <div>
            <button
              onClick={() => toggleFilterSection("gender")}
              className="w-full flex items-center justify-between py-2 px-2 rounded-lg transition-colors hover:bg-gray-50"
            >
              <span className="text-sm font-medium text-gray-700">Gender</span>
              <ChevronDown
                className={`h-4 w-4 transition-transform ${filterSectionsOpen.gender ? "rotate-0" : "-rotate-90"
                  } text-gray-500`}
              />
            </button>
            {filterSectionsOpen.gender && (
              <div className="mt-2 space-y-1.5 pl-2">
                {filterOptions.gender.map((option) => (
                  <button
                    key={option}
                    onClick={() => onFilterChange("gender", option)}
                    className={`w-full text-left px-3 py-1.5 rounded-lg text-sm transition-all ${selectedFilters.gender.includes(option)
                        ? "bg-orange-500 text-white font-medium shadow-md shadow-orange-500/20"
                        : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                      }`}
                  >
                    {option.charAt(0).toUpperCase() + option.slice(1)}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Age Category Filter */}
          <div>
            <button
              onClick={() => toggleFilterSection("ageCategory")}
              className="w-full flex items-center justify-between py-2 px-2 rounded-lg transition-colors hover:bg-gray-50"
            >
              <span className="text-sm font-medium text-gray-700">Age Category</span>
              <ChevronDown
                className={`h-4 w-4 transition-transform ${filterSectionsOpen.ageCategory ? "rotate-0" : "-rotate-90"
                  } text-gray-500`}
              />
            </button>
            {filterSectionsOpen.ageCategory && (
              <div className="mt-2 space-y-1.5 pl-2">
                {filterOptions.ageCategory.map((option) => (
                  <button
                    key={option}
                    onClick={() => onFilterChange("ageCategory", option)}
                    className={`w-full text-left px-3 py-1.5 rounded-lg text-sm transition-all ${selectedFilters.ageCategory.includes(option)
                        ? "bg-orange-500 text-white font-medium shadow-md shadow-orange-500/20"
                        : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                      }`}
                  >
                    {ageCategoryLabel(option)}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
}
